import React from 'react'
import Route from "../../Route";

const Association = () => {
    return (
        <>
            <div className="inner-head bg-animate">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-8 col-md-offset-2">
                            <h3>Association</h3>
                        </div>
                    </div>
                </div>
            </div>


            <div className="clearfix"></div>
            <div className="inner-page">
                <div className="container">
                    <div className="row">
                        <p>
                            L’association créé en 2021 par les anciens etudiants CONGOLAIS de l'Institut Africain d'Informatique (IAI),
                            est une association d’entraide à périmètre d’action national et international, apolitique à double caractère, social et économique centré sur le développement humain.
                            <br/>
                            Le but de l'association est de contribuer au développement du Congo dans le domaine des Technologies de l'Information et des Communication (TIC)
                            en favorisant ainsi la mutualisation et la complémentarité des compétences de tous les anciens étudiants Congolais de l'Institut Africain d'Informatique (IAI).
                            <br/><br/>
                            Elle entend regrouper tous les anciens étudiants Congolais de l’Institut Africain d’Informatique (AAEC-IAI) de nationalité congolaise ayant adhérés quel que soit leur lieu de résidence.
                            Elle joue un rôle prépondérant à promouvoir les technologies de l’information et de la communication pour le développement du Congo.
                            <br/><br/>
                            Le siège de l’association des anciens IAI CONGO est fixé à Brazzaville. La devise de l’association est <strong><em>« Entraide-Travail–Résultat ». </em></strong>
                            <br/>La devise est obligatoirement scandée au début et à la fin de la tenue de l’assemblée général ou de toute retrouvaille des mutualistes si nécessaire.
                            <br/><br/>

                            <a href="/join">L’adhésion</a> à l’association s'élève à <strong>10 000 FCFA</strong>.
                            En suite, les cotisations statutaires au sein de l’association des anciens IAI sont mensuelles s’élèvent à <strong>3 000 FCFA</strong>, et sont obligatoires pour tous les membres actifs.

                            <br/>En effet, ces cotisations doivent être versées au plus tard le <strong>15 du mois suivant</strong>,
                            ce qui permettra au trésorier de faire le point au plus tard le <strong>20 du même mois</strong>.
                            <br/>Toutefois les cotisations peuvent être versées par anticipation afin de constituer la réserve du Membre au sein de l’association.
                            <br/>Reserve qui ne peut être reprise.
                            <br/>
                        </p>

                        <p>
                            Pour en savoir plus, prière de lire les
                            <a href={Route.APIDownloadFile.status} target="_blank"> statuts</a> et le
                            <a href={Route.APIDownloadFile.procedureRules} target="_blank"> règlement intérieur</a> de l'association.
                        </p>
                    </div>

                </div>
            </div>

        </>
    );
}

export default Association;